import {useEffect, useState} from "react";

export const useTimeZone = () => {
    const [timeZone, setTimeZone] = useState<string>(getTimeZone())
    useEffect(()=> {
        setTimeZone(getTimeZone())
    }, [])
    return timeZone
}

const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone